export default {
  user: null,
  company: null,
  tokens: null,
}
